<template>
<div class="page_order page">
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    </van-list> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="(order,index) in orderList" :key="index">
                    <div class="item_t">
                        <div class="item_t_t">
                            <img :src="order.tradesman_thumb ? ($publicData.withHttpStart(order.tradesman_thumb) ? order.tradesman_thumb : imageUrl+order.tradesman_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title">{{ order.tradesman_name }}</div>
                        </div>
                        <!-- <div class="status">{{ order.statusTitle }}</div> -->
                    </div>
                    <div  v-for=" (goods,index) in order.order_good" :key="index" @click="goOrderDetail(order)">
                        <div class="item_nr">
                            <div class="item_nr_l">
                                <img :src="goods.thumb ? imageUrl+goods.thumb: $publicData.intangibleDefault" alt="" class="tu">
                            </div>
                            <div class="item_nr_r">
                                <div class="item_nr_r_t">
                                    <div class="title slh">{{ goods.title }}</div>
                                    <div class="info">
                                        <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                                        <span class="nums">x{{ goods.num }}</span>
                                    </div>
                                </div>
                                <div class="sku">{{ goods.spec_name }}</div>
                            </div>
                        </div>
                        <div class="item_b item_saled">
                            <div class="">退款状态</div>
                            <div class="">{{goods.status==0?'退款中':(goods.status==1?'退款成功':'退款失败')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../.././vuex/mutation_types";
import Bridge from '../../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: this.$route.query.status, // 售后 对应5
            orderList: [],
            token: '',
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
        };
    },
    created: function () {

    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '售后',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.onRefresh();
        }

    },
    methods: {
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                status: this.active,
                page: this.page,
                size: this.size
            }
            this.$api.shop.orderList(params).then(res => {
                if (res.code == 200) {

                    var list = res.result.list
                    if (this.page == 1) {
                        this.orderList = list
                    } else {
                        var old = this.orderList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.orderList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 订单详情
        goOrderDetail(order) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + order.order_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/order/detail',
                    query: {
                        orderId: order.order_id,
                        afterSale: 1
                    }
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
